import api from './api';

export const vendorAccountingApi = {
    async getDashboardStats(): Promise<{
        today: { revenue: number; orders: number; courierFees: number; netEarnings: number };
        thisWeek: { revenue: number; orders: number; courierFees: number; netEarnings: number };
        thisMonth: { revenue: number; orders: number; courierFees: number; netEarnings: number };
    }> {
        const response = await api.get('/vendor/accounting/dashboard');
        return response.data;
    },

    async getSummary(params: {
        startDate: string;
        endDate: string;
    }): Promise<{
        vendorId: string;
        totalRevenue: number;
        totalCourierFees: number;
        totalCommission: number;
        totalExpenses: number;
        netEarnings: number;
        orderCount: number;
        averageOrderValue: number;
        profitMargin: number;
        commissionRate: number;
    }> {
        const response = await api.get('/vendor/accounting/summary', { params });
        return response.data;
    },

    async getOrderFinancials(params: {
        startDate: string;
        endDate: string;
        page?: number;
        limit?: number;
    }): Promise<{
        orders: Array<{
            orderId: string;
            orderNo: string;
            totalRevenue: number;
            courierFee: number;
            vendorCommission: number;
            netEarnings: number;
            status: string;
            reportedDate: string;
            courierName?: string;
        }>;
        total: number;
        hasMore: boolean;
    }> {
        const response = await api.get('/vendor/accounting/orders', { params });
        return response.data;
    },

    async getCourierPayments(params: {
        startDate: string;
        endDate: string;
    }): Promise<{
        couriers: Array<{
            courierId: string;
            courierName: string;
            totalPaid: number;
            deliveryCount: number;
            averagePerDelivery: number;
            deliveries: Array<{
                orderId: string;
                orderNo: string;
                amount: number;
                deliveredAt: string;
            }>;
        }>;
        summary: {
            totalPaid: number;
            totalDeliveries: number;
            courierCount: number;
            averagePerDelivery: number;
        };
    }> {
        const response = await api.get('/vendor/accounting/courier-payments', { params });
        return response.data;
    },
};
